<template>
  <div>
    <div>
      <AnimatedText />
      <div class="font-weight-bold destop-sub-text">
        <span>Delivery made simple, faster and easier.</span><br />
        <span
          >You Wrap. We Collect. We
          <span class="sokoDeep--text">Deliver!</span></span
        >
      </div>
    </div>

    <div>
      <v-btn
        x-large
        class="sokoDeep white--text my-5 font-weight-bold responsive-btn"
        router
        link
        to="/delivery"
        >schedule now <v-icon small right>mdi-arrow-right</v-icon></v-btn
      >
    </div>
  </div>
</template>

<script>
import AnimatedText from "./AnimatedText";

export default {
  name: "ResponsiveText",

  components: {
    AnimatedText,
  },
};
</script>

<style scoped>
.destop-sub-text * {
  font-size: 1.1rem;
}

@media (max-width: 960px) {
  /* mobile and below */
  /* .destop-sub-text * {
    font-size: 0.9rem;
  }
  .destop-sub-text {
    padding-top: 0.5rem;
    font-size: 1rem;
  } */
}

@media (max-width: 960px) {
  .responsive-btn {
    border-radius: 50px;
  }
}
</style>
